import React from 'react'
import { motion } from 'framer-motion'
// import bgvideo from "./../../assets/herovideo.mp4"
import waveman from "../../assets/images/waveman.png"
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import './About.scss'
const About = () => {
    return (
        <div className="About">
            {/* <video src={bgvideo} autoPlay loop muted /> */}
            <div className="AboutContainer">
                <div className="AboutContainerLeft">
                    <div className="card">
                        <div className="card__side card__side--front">
                            
                        </div>
                        <div className="card__side card__side--back card__side--back">
                            
                        </div>
                    </div>
                </div>
                <div className="AboutContainerRight">
                    <motion.div
                        whileInView={{ opacity: [0, 1] }}
                        transition={{ duration: 0.8, delayChildren: 0.5 }}
                        className="about-img"
                    >
                        <img width="100%" className='Waveman' src={waveman} alt="Waveman" />
                    </motion.div>
                    <div className="button-container-2">
                        <span className="mas">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>
                        </span>
                        <button type="button" className="Hove">播放
                            {/* <svg width="16" height="12" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.62381 0L8.05636 0.50423L10.4638 2.64347H0V3.3566H10.4637L8.05636 5.49577L8.62381 6L12 3L8.62381 0Z" fill="currentColor">
                    </path></svg> */}
                        </button>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default About
